import PropTypes from 'prop-types';
import { useState } from 'react';
import { Button, Typography } from '@mui/material';
import { DeleteOutline } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { enqueueSnackbar } from 'notistack';
import axiosInstance from '../../utils/axios';
import { objectToFormData } from '../../utils/objectToFormData';
import { AGGridCheckboxColDefaults } from './AGGridCheckboxColDefaults';

export function AGGridDeleteCol(setData) {
  return AGGridCheckboxColDefaults(setData, 'selectedForDelete', 'Delete');
}

DeleteStartButton.propTypes = {
  disabled: PropTypes.bool,
  startDeletingItems: PropTypes.bool,
  setStartDeletingItems: PropTypes.func,
  setData: PropTypes.func
}

export function DeleteStartButton({ disabled, startDeletingItems, setStartDeletingItems, setData })
{
  return <Button variant="contained" color="error" startIcon={<DeleteOutline />} sx={{ marginTop: "auto" }} size="small" disabled={disabled}
    onClick={() => { setStartDeletingItems(!startDeletingItems); if (startDeletingItems) setData(data => data.map(x => ({ ...x, selectedForDelete: false }))) }}>
    <Typography>{startDeletingItems ? "Cancel Delete" : "Select Items To Delete"}</Typography>
  </Button>;
}

DeleteSubmitButton.propTypes = {
  setStartDeletingItems: PropTypes.func,
  setData: PropTypes.func,
  url: PropTypes.string,
  data: PropTypes.array,
  afterDelete: PropTypes.func,
}

export function DeleteSubmitButton({ setStartDeletingItems, url, data, setData, afterDelete = null }) {
  const [submitItemsForDelete, setSubmitItemsForDelete] = useState(false);

  const onSubmit = () => {
    setSubmitItemsForDelete(true);
    axiosInstance.post(url, objectToFormData({ ids: data.filter(x => x.selectedForDelete).map(x => x.id) }))
      .then(() => enqueueSnackbar("Items deleted", { variant: "success" }))
      .catch(() => enqueueSnackbar("Failed to delete items", { variant: "error" }))
      .finally(() => {
        setData(currData => currData.filter(x => !x.selectedForDelete));
        setStartDeletingItems(false);
        setSubmitItemsForDelete(false);
        if (afterDelete) afterDelete(data.filter(x => !x.selectedForDelete))
      });
  }

  return <LoadingButton loading={submitItemsForDelete} variant="contained" color="error" startIcon={<DeleteOutline />} sx={{ marginTop: "auto" }}
    size="small" onClick={onSubmit}>
    <Typography>Delete Selected Items</Typography>
  </LoadingButton>;
}
